/**
 * The Product sync list's page select-all box (BLU-1522 S6a).
 *
 * What the box SHOWS and what a click DOES come from this one function, so the
 * two can never disagree (they used to be worked out in two places: the PAP
 * cap could leave the box half ticked while a click cleared it).
 *
 *   - none of the page's rows ticked -> unchecked; a click ticks them all.
 *   - every row ticked               -> checked;   a click unticks them all.
 *   - some ticked (rows unticked one by one after select all, or the PAP cap
 *     stopped it)                    -> indeterminate; a click unticks them
 *     all. A click never ticks again the rows the operator just unticked.
 *
 * Only the page's own rows move. Products picked on another page or through
 * another filter pass stay picked (the floating bar's Clear drops everything).
 */
export type PageSelectAllState = boolean | 'indeterminate';

export function pageSelectAllState(rowIds: readonly string[], isSelected: (id: string) => boolean): PageSelectAllState {
  let ticked = 0;
  for (const id of rowIds) if (isSelected(id)) ticked += 1;
  if (ticked === 0) return false;
  return ticked === rowIds.length ? true : 'indeterminate';
}

/** A click on the box: tick the page only when nothing on it is ticked; otherwise untick it. */
export function pageSelectAllAction(state: PageSelectAllState): 'select' | 'clear' {
  return state === false ? 'select' : 'clear';
}

/**
 * Every product the last "Select all matching" fetched is still ticked: the
 * bar's button then turns into "Deselect all matching", which unticks exactly
 * those (never an earlier filter pass's picks). False when nothing was fetched.
 */
export function allMatchingSelected(matchingIds: readonly string[] | null, isSelected: (id: string) => boolean): boolean {
  return matchingIds !== null && matchingIds.length > 0 && matchingIds.every(isSelected);
}
